export default "__VITE_ASSET__DDVObKEF__";